import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { useCheckListToggle } from 'common/Prose/Toolbar/hooks/useCheckListToggle'
import { observer } from 'mobx-react-lite'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'
import { Button } from 'common/Prose/Toolbar/ToolbarBravo/Buttons/Button'
import { ShortcutAwareTooltip } from 'common/Prose/utils/ShortcutAwareTooltip'
import SimpleDropdownStyles from '../SimpleDropdown/SimpleDropdown.module.scss'
import cx from 'classnames'

export const CheckListButton = observer(() => {
  const view = useEditorView()
  const { active, handleClick, disabled } = useCheckListToggle(view)

  return (
    <ShortcutAwareTooltip label="Checklist">
      <Button
        aria-label="Checklist"
        active={active}
        disabled={disabled}
        onClick={handleClick}
        className={cx(SimpleDropdownStyles.dropdownButton, { [SimpleDropdownStyles.active]: active })}
      >
        <ToolbarIcon name={IconName.CheckList} />
      </Button>
    </ShortcutAwareTooltip>
  )
})
